import { render, staticRenderFns } from "./ProductVariantHandler.vue?vue&type=template&id=60a3ff60"
import script from "./ProductVariantHandler.vue?vue&type=script&lang=js"
export * from "./ProductVariantHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports